document.documentElement.classList.add('js');
const menuToggle = document.querySelector('[data-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');
const menuBackdrop = document.querySelector('[data-menu-backdrop]');

function openMenu() {
  mobileMenu.hidden = false;
  menuBackdrop.hidden = false;
  requestAnimationFrame(() => {
    mobileMenu.classList.add('is-open');
    menuBackdrop.classList.add('is-open');
  });
  menuToggle.setAttribute('aria-expanded', 'true');
  document.body.classList.add('menu-open');
}

function closeMenu() {
  mobileMenu.classList.remove('is-open');
  menuBackdrop.classList.remove('is-open');
  menuToggle.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('menu-open');
  setTimeout(() => {
    mobileMenu.hidden = true;
    menuBackdrop.hidden = true;
  }, 220);
}

document.addEventListener('click', (event) => {
  if (event.target.closest('[data-menu-toggle]')) openMenu();
  if (event.target.closest('[data-menu-close]') || event.target.closest('[data-menu-backdrop]')) closeMenu();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && menuToggle?.getAttribute('aria-expanded') === 'true') closeMenu();
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const track = gallery.querySelector('[data-gallery-track]');
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  const dots = [...gallery.querySelectorAll('[data-gallery-dot]')];
  if (!track || slides.length < 2) return;

  const setActive = (index) => {
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
      if (dotIndex === index) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  };

  let ticking = false;
  track.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      setActive(index);
      ticking = false;
    });
  }, { passive: true });

  dots.forEach((dot, index) => dot.addEventListener('click', () => {
    track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
  }));
});
